<div class="user-action" *ngIf="uiService.visibleByRole([Role.manager, Role.administrator])">
  <button mat-raised-button color="primary" (click)="createUser()">
    <mat-icon>add</mat-icon>
    {{ 'button.add-user' | translate }}
  </button>
</div>
<app-users-grid #UsersGridComponent></app-users-grid>